import { fileUrl } from "@/lib/api";

const TEMPLATES = {
  mesh: "mesh-pattern text-white",
  minimal: "bg-white border border-[#E2E8F0] text-[#0F172A]",
  botanical: "bg-[#0F8964] text-white botanical-pattern",
  luxe: "luxe-pattern border border-[#1E2D26] text-white",
};

function QrBox({ value, dark }) {
  const url = `https://api.qrserver.com/v1/create-qr-code/?size=180x180&margin=10&data=${encodeURIComponent(value)}`;
  return (
    <div className={`p-1.5 sm:p-2 rounded-lg sm:rounded-xl flex-shrink-0 ${dark ? "bg-white" : "bg-white border border-[#E2E8F0]"}`}>
      <img src={url} alt="QR" className="w-[78px] h-[78px] sm:w-[100px] sm:h-[100px] lg:w-[120px] lg:h-[120px] block" />
    </div>
  );
}

export default function MembershipCard({ tenant, user, variant, customImagePath }) {
  const v = variant || tenant?.card_template || "mesh";
  const cls = TEMPLATES[v] || TEMPLATES.mesh;
  // If a per-tier custom image is provided, use it as the background
  const customBg = customImagePath ? fileUrl(customImagePath) : null;
  // When custom image is used, force dark text style (white) for readability with grain overlay
  const dark = customBg ? true : (v === "mesh" || v === "botanical" || v === "luxe");
  const logo = tenant?.logo_path ? fileUrl(tenant.logo_path) : null;
  const subdued = dark ? "text-white/75" : "text-[#59665F]";

  return (
    <div
      data-testid="membership-card"
      className={`relative overflow-hidden rounded-2xl p-4 sm:p-5 lg:p-7 aspect-[1.586/1] w-full max-w-[460px] grain shadow-[0_30px_80px_-30px_rgba(15,137,100,0.45)] ${customBg ? "text-white" : cls}`}
    >
      {customBg && (
        <>
          <img src={customBg} alt="" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/15 to-black/10" />
        </>
      )}
      <div className="relative z-10 flex flex-col h-full justify-between">
        <div className="flex items-start justify-between gap-4">
          <div className="flex items-center gap-3">
            {logo ? (
              <img src={logo} alt={tenant.name} className={`h-8 w-8 rounded-lg object-cover ${dark ? "bg-white/10 p-1" : ""}`} />
            ) : (
              <div className={`h-8 w-8 rounded-lg ${dark ? "bg-white/15" : "bg-[#0F8964]/10"} flex items-center justify-center font-display font-bold text-sm`}>
                {tenant?.name?.[0] || "M"}
              </div>
            )}
            <div>
              <p className={`label-eyebrow ${subdued}`}>Member</p>
              <p className="font-display font-semibold leading-tight text-[15px]">{tenant?.name || "MedRewards"}</p>
            </div>
          </div>
          <span className={`label-eyebrow px-3 py-1 rounded-full ${dark ? "bg-white/20" : "bg-[#0F8964]/10 text-[#0F8964]"}`}>
            {user?.tier || "Standard"}
          </span>
        </div>

        <div className="flex items-end justify-between gap-3 sm:gap-4">
          <div className="min-w-0">
            <p className={`label-eyebrow mb-1 ${subdued}`}>Patient</p>
            <p className="font-display text-base sm:text-lg lg:text-2xl font-semibold tracking-tight leading-tight truncate">{user?.name || "Guest"}</p>
            <p className={`text-[10px] sm:text-xs mt-0.5 sm:mt-1 ${subdued}`}>ID · {user?.id?.slice(-8).toUpperCase()}</p>
          </div>
          <QrBox value={user?.id || "guest"} dark={dark} />
        </div>
      </div>
    </div>
  );
}
